// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2wIxH","colMaxWidth":"Table_colMaxWidth__w7KAN"};